const parseNumber = (value, fallback) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const initBlogPickerSwiper = (root) => {
  if (typeof window.Swiper !== 'function') return;
  if (!root) return;

  const swiperEl = root.querySelector('.blog-picker__swiper');
  if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

  const wrap = swiperEl.closest('.blog-picker__swiper-wrap');
  if (!wrap) return;

  const prevEl = wrap.querySelector('.blog-picker__arrow--prev');
  const nextEl = wrap.querySelector('.blog-picker__arrow--next');
  const paginationEl = wrap.querySelector('.blog-picker__pagination');

  const slidesMobile = parseNumber(root.dataset.slidesMobile, 1.2);
  const slidesTablet = parseNumber(root.dataset.slidesTablet, 2);
  const slidesDesktop = parseNumber(root.dataset.slidesDesktop, 3);
  const spaceMobile = parseNumber(root.dataset.spaceMobile, 12);
  const spaceTablet = parseNumber(root.dataset.spaceTablet, 16);
  const spaceDesktop = parseNumber(root.dataset.spaceDesktop, 20);

  const instance = new Swiper(swiperEl, {
    slidesPerView: slidesMobile,
    slidesPerGroup: 1,
    spaceBetween: spaceMobile,
    centeredSlides: false,
    loop: false,
    // mobile: default (< 769)
    // tablet: 769–1024
    // desktop: > 1024
    breakpoints: {
      769: {
        slidesPerView: slidesTablet,
        spaceBetween: spaceTablet
      },
      1025: {
        slidesPerView: slidesDesktop,
        spaceBetween: spaceDesktop
      }
    },
    navigation:
      prevEl && nextEl
        ? {
            nextEl,
            prevEl
          }
        : false,
    pagination: paginationEl
      ? {
          el: paginationEl,
          clickable: true
        }
      : false,
    on: {
      init() {
        swiperEl.classList.add('swiper-initialized');
      }
    }
  });

  swiperEl._blogPickerSwiper = instance;
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.blog-picker[data-section-id]').forEach((root) => {
    initBlogPickerSwiper(root);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.matches('.blog-picker[data-section-id]')) {
    initBlogPickerSwiper(event.target);
  }
});
